import { render, staticRenderFns } from "./AddKeyDialog.vue?vue&type=template&id=007ff27b&scoped=true&"
import script from "./AddKeyDialog.vue?vue&type=script&lang=ts&"
export * from "./AddKeyDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AddKeyDialog.vue?vue&type=style&index=0&id=007ff27b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007ff27b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VDialog})
